var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('b-row',{attrs:{"id":"body"}},[_c('b-col',{attrs:{"lg":"2"}},[_c('Navigation')],1),_c('b-col',{attrs:{"lg":"10"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }